import { render, staticRenderFns } from "./purchaseReceivingList.vue?vue&type=template&id=7ec74c4f&scoped=true"
import script from "./purchaseReceivingList.vue?vue&type=script&lang=js"
export * from "./purchaseReceivingList.vue?vue&type=script&lang=js"
import style0 from "./purchaseReceivingList.vue?vue&type=style&index=0&id=7ec74c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec74c4f",
  null
  
)

export default component.exports